import PaymentsInfoState from '../interfaces/states/PaymentsInfoState';

import * as Const from '../constants';

const initState: PaymentsInfoState = {
  paymentsInfoData: {
    data: [],
  },
  isLoading: false,
  isError: false,
};

export default function paymentsInfo (state: PaymentsInfoState = initState, action): PaymentsInfoState {
  switch (action.type) {

    case Const.FETCH_PAYMENTS_INIT:
      return {
        ...initState,
        isLoading: false,
      };

    case Const.FETCH_PAYMENTS_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.FETCH_PAYMENTS_SUCCESS:
      return {
        ...state,
        paymentsInfoData: action.payload,
        isLoading: false,
        isError: false,
      };

    case Const.FETCH_PAYMENTS_FAIL:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    default:
      return state;
  }
}
